export default "__VITE_ASSET__raSBAY8R__"